"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueChartjs = require("vue-chartjs");
var _chart = _interopRequireDefault(require("chart.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
_chart.default.defaults.global.legend.display = false;
var _default2 = exports.default = {
  extends: _vueChartjs.Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    options: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};